import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import i18n from './vue-i18n';
import pt from 'vuetify/es5/locale/pt'


Vue.use(Vuetify);

export default new Vuetify({

	lang: {
        t: (key, ...params) => i18n.t(key, params),
        locales: { pt },
        current: 'pt',
	},
	theme: {
		themes: {
			light: {
				primary: '#F47E2F',
				secondary: '#55C2BC',
			},
		},
	},
});